import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { SEO } from "../components/SEO";
import { Reveal } from "../components/Reveal";
import { useContactData } from "../hooks/useContactData";

export const Resources = () => {
  const contactData = useContactData();
  const articles = contactData.resourceArticles || [];

  return (
    <>
      <SEO
        title="Resources & Guides"
        description="Practical guides for CA and tax firms: GST workflows, timesheets, WhatsApp reminders, cloud security, Excel migration, and plan selection."
        canonicalUrl={`${contactData.websiteUrl}/resources`}
        breadcrumbs={[
          { name: "Home", item: "/" },
          { name: "Resources", item: "/resources" },
        ]}
      />

      <section className="pt-20 pb-16 text-center px-4 max-w-3xl mx-auto space-y-5">
        <span className="text-xs font-black uppercase tracking-[0.2em] text-primary-600 dark:text-primary-400 font-heading">
          Knowledge Hub
        </span>
        <h1 className="font-heading font-black text-4xl sm:text-5xl text-foreground leading-[0.95] tracking-tighter">
          Resources for Modern Practice Teams
        </h1>
        <p className="text-text-sub text-lg font-medium">
          Short, practical articles on digitizing Indian professional services
          firms with OOMS.
        </p>
      </section>

      <section className="pb-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {articles.map((article, idx) => (
            <Reveal key={article.slug} delay={idx * 0.05}>
              <Link
                to={`/resources/${article.slug}`}
                className="group flex h-full flex-col rounded-[32px] border border-border bg-surface p-8 shadow-xl shadow-foreground/5 transition-all duration-300 hover:border-primary-500 hover:-translate-y-1"
              >
                <div className="mb-4 flex items-center justify-between gap-3">
                  <span className="rounded-full bg-primary-50 px-3 py-1 text-[10px] font-black uppercase tracking-wider text-primary-700 dark:bg-primary-950/40 dark:text-primary-400">
                    {article.category}
                  </span>
                  <span className="inline-flex items-center gap-1 text-[11px] font-bold text-text-sub">
                    <Clock className="h-3.5 w-3.5" />
                    {article.readMinutes} min
                  </span>
                </div>
                <h2 className="font-heading font-black text-xl text-foreground leading-snug mb-3 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h2>
                <p className="text-sm text-text-sub font-medium leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-black text-primary-600 uppercase tracking-wider">
                  Read article <ArrowRight className="h-4 w-4" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
};

export default Resources;
